import React, {useState} from 'react';
import {useMutation} from "@apollo/client";
import {CREATE_DEVICE_TOKEN, SIGNIN_MUTATION} from '../../queries/mutations';
import Login from './login';


const LoginContainer = ({handleLoggedIn}) => {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [error, setError] = useState();

  const [createDeviceToken] = useMutation(CREATE_DEVICE_TOKEN, {
    onCompleted({deviceToken}) {
      console.log(`Creating device token in the backend succeeded`)
    },
    onError(error) {
      console.error(`Creating device token in the backend failed: ${error}`)
    }
  })

  const [signIn] = useMutation(SIGNIN_MUTATION, {
    onCompleted({ signInUser }) {
      if (!signInUser) {
        setError('Der Benutzername oder das Passwort ist nicht korrekt.');
      } else {
        setError(null);
  
        // Save token and user ID to localStorage
        localStorage.setItem('token', signInUser.token);
        localStorage.setItem('user_id', signInUser.user.id);

        handleLoggedIn();
  
        const deviceToken = localStorage.getItem('deviceToken');

        if (typeof deviceToken !== 'string') {
          console.error('Device token is not a string:', deviceToken);
          return;
        }
  
        createDeviceToken({
          variables: {
            token: deviceToken, 
          },
          context: {
            headers: {
              authorization: signInUser.token, 
            },
          },
        });
      }
    },
    onError(err) {
      if (err.graphQLErrors[0]) setError(err.graphQLErrors[0].message);
    },
  });

  const authenticate = () => {
    if (!email || !password){
        return setError('Der Benutzername oder das Passwort ist nicht korrekt.');
    }

    signIn({
      variables: {email: email, password: password},
    });
  };

  return (
    <Login
      error={error}
      setEmail={setEmail}
      setPassword={setPassword}
      authenticate={authenticate}
    />
  );
};

export default LoginContainer;
